// FD & other investments: the types the backend accepts, and which of them
// carry an interest rate / maturity (the rest are market-linked or free-form).

export const INVESTMENT_TYPES = [
    { value: 'FIXED_DEPOSIT', label: 'Fixed Deposit (FD)', short: 'FD', icon: 'mdi:bank-outline', color: 'tw-bg-rose-50 tw-text-rose-700' },
    { value: 'RECURRING_DEPOSIT', label: 'Recurring Deposit (RD)', short: 'RD', icon: 'mdi:calendar-sync-outline', color: 'tw-bg-orange-50 tw-text-orange-700' },
    { value: 'MUTUAL_FUND', label: 'Mutual Fund', short: 'Mutual Fund', icon: 'mdi:chart-areaspline', color: 'tw-bg-indigo-50 tw-text-indigo-700' },
    { value: 'BOND', label: 'Bond / Debenture', short: 'Bond', icon: 'mdi:file-certificate-outline', color: 'tw-bg-sky-50 tw-text-sky-700' },
    { value: 'GOVT_SECURITY', label: 'Govt. Security / T-Bill', short: 'Govt. Security', icon: 'mdi:shield-check-outline', color: 'tw-bg-emerald-50 tw-text-emerald-700' },
    { value: 'SHARES', label: 'Shares / Equity', short: 'Shares', icon: 'mdi:chart-line', color: 'tw-bg-violet-50 tw-text-violet-700' },
    { value: 'POST_OFFICE', label: 'Post Office Scheme', short: 'Post Office', icon: 'mdi:email-outline', color: 'tw-bg-amber-50 tw-text-amber-700' },
    { value: 'OTHER', label: 'Other Investment', short: 'Other', icon: 'mdi:briefcase-outline', color: 'tw-bg-gray-100 tw-text-gray-700' },
];

export const INTEREST_BEARING = ['FIXED_DEPOSIT', 'RECURRING_DEPOSIT', 'BOND', 'GOVT_SECURITY', 'POST_OFFICE'];
export const MARKET_LINKED = ['MUTUAL_FUND', 'SHARES'];

export const typeMeta = (value) =>
    INVESTMENT_TYPES.find(t => t.value === value) || INVESTMENT_TYPES[0];

// Label for the certificate / folio / account number field.
export const numberLabel = (type) => ({
    MUTUAL_FUND: 'Folio Number',
    SHARES: 'Demat / Holding Reference',
    BOND: 'Certificate / ISIN',
    GOVT_SECURITY: 'Certificate / ISIN',
    RECURRING_DEPOSIT: 'RD Account Number',
    POST_OFFICE: 'Account / Certificate Number',
    OTHER: 'Reference Number',
}[type] || 'FD Number');
